// extracted by mini-css-extract-plugin
export default {"CustomPropertySelectPanelButton":"CustomPropertySelectPanel-module__CustomPropertySelectPanelButton--Sdiii"};